/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_On_TimeInputs */

const vi_report_delivery_on_time = /** @type {(inputs: Report_Delivery_On_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đúng hạn`)
};

/**

* @param {Report_Delivery_On_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_on_time = /** @type {((inputs?: Report_Delivery_On_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_On_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_on_time(inputs)
});